import axios from "axios";

type ClientHandProps = {
  id: string | undefined;
};

export async function getClienthandDataAction({ id }: ClientHandProps) {
  const token = localStorage.getItem("token");

  return await axios
    .get(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/client/user-hand?id=${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
